// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import '../lib/image-preview';
import '../lib/polyfills';
import autosize from 'autosize';
import Rails from '@rails/ujs';
import ReactOnRails from 'react-on-rails';
import SearchWidget from '../components/SearchWidget';
import UserAvatar from '../components/UserAvatar';
import {
  getUrlParams,
  setUrlParams,
  formattedTextForDate,
} from '../lib/utils/wca';
import '../lib/acknowledge-cookies';
// Imported for its side effects: it populates the global `window.I18n` store.
import '../lib/i18n';

Rails.start();
require('jquery');

// Build up the window.wca environment
window.wca = window.wca || {};

// Setting up autosize
$(() => {
  autosize($('textarea:not(.no-autosize)'));
  // Setup wca-local-time users
  $('.wca-local-time').each(function init() {
    const data = $(this).data();
    const { utcTime, locale } = data;
    $(this).text(formattedTextForDate(utcTime, locale));
  });
});

// Export some helpers
window.wca.getUrlParams = getUrlParams;
window.wca.setUrlParams = setUrlParams;

// Every other component is auto-bundled: React on Rails generates a pack per
// file in app/webpacker/app and appends it to the page rendering that
// component. These two can't use that mechanism because layouts/_navigation
// renders them, i.e. after `javascript_pack_tag` has already run and appending
// another pack would raise. They appear on every page anyway, so they belong in
// this always-loaded pack. Their call sites pass `auto_load_bundle: false`.
ReactOnRails.register({
  SearchWidget,
  UserAvatar,
});
